<template>
  <span class="typo-paragraph select-none font-bold leading-[0.91] block">
    <span>Museum</span><br />
    <span>für Gestaltung</span><br />
    <span>Zürich</span>
  </span>
</template>
